/* eslint-disable max-len */
import React from 'react';

function SVGApiLayer(props) {
  return (
    <svg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 634 430' {...props}>
      <g filter='url(#prefix__filter0_d_api_layer)'>
        <path
          d='M86.649 62.43l325.857-48.877 177.165 216.892-328.39 49.074L86.649 62.431z'
          fill='url(#prefix__paint0_linear_api_layer)'
        />
        <path d='M589.709 230.485v-7.175l-6.347 1.104v6.071h6.347z' fill='#2E4295' />
        <path d='M86.572 51.715L412.597 2.962l177.355 220.424-326.035 48.705L86.572 51.715z' fill='#6275C2' />
        <rect
          x={1.616}
          y={0.631}
          width={288.374}
          height={249.098}
          rx={4}
          transform='matrix(.989 -.1479 .62694 .77907 115.795 61.533)'
          stroke='#fff'
          strokeWidth={2}
        />
        <path
          transform='matrix(.62694 .77907 -.989 .1479 188.026 50.795)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h250.657'
        />
        <path
          transform='matrix(.989 -.1479 .62694 .77907 242.335 217.928)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h290.374'
        />
        <path
          transform='matrix(.62694 .77907 -.989 .1479 331.181 29.389)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h250.657'
        />
        <path
          transform='matrix(.989 -.1479 .62694 .77907 151.587 105.161)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h290.374'
        />
        <path
          transform='matrix(.62694 .77907 -.989 .1479 259.604 40.092)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h250.657'
        />
        <path
          transform='matrix(.989 -.1479 .62694 .77907 196.96 161.544)'
          stroke='#9EB4F0'
          strokeWidth={2}
          d='M0-1h290.374'
        />
        <g opacity={0.81} filter='url(#prefix__filter1_f_api_layer)' fill='#3B4B8D'>
          <path d='M339.877 190.734l-69.882-51.054-26.54 3.968 18.476 58.742 23.927-3.578-2.659-6.795 25.077-3.75 7.673 6.045 23.928-3.578zm-48.901-16.109l-13.792 2.063-7.344-18.727 21.136 16.664zm73.764 12.391l-13.909-17.284 16.091-2.406c16.299-2.438 18.188-12.31 9.975-22.516-8.28-10.288-23.945-17.536-40.245-15.098l-37.197 5.562 44.179 54.898 21.106-3.156zm-12.192-33.77l-13.374 2-6.955-8.642 13.374-2c3.552-.531 7.5.446 9.884 3.409 2.318 2.881.623 4.702-2.929 5.233zm81.373 23.425l-44.179-54.898-21.106 3.156 44.179 54.898 21.106-3.156z' />
        </g>
        <path
          d='M342.037 171.775l-64.189-46.896-24.377 3.646 16.97 53.956 21.978-3.287-2.442-6.241 23.033-3.444 7.049 5.552 21.978-3.286zm-44.917-14.797l-12.668 1.894-6.746-17.201 19.414 15.307zm67.755 11.381l-12.776-15.876 14.78-2.21c14.972-2.239 16.706-11.307 9.162-20.681-7.605-9.45-21.994-16.107-36.966-13.869l-34.166 5.11 40.579 50.426 19.387-2.9zm-11.199-31.019l-12.285 1.838-6.388-7.939 12.285-1.837c3.263-.488 6.888.41 9.079 3.132 2.129 2.646.572 4.319-2.691 4.806zm74.744 21.517l-40.58-50.426-19.386 2.899 40.579 50.426 19.387-2.899z'
          fill='#9CA8D9'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M344.148 172.36l-24.197 3.618-7.049-5.552-21.525 3.219 2.442 6.241-24.197 3.618-17.511-55.677 25.8-3.858 66.237 48.391zm-54.173.593l23.034-3.444 7.049 5.552 21.978-3.286-64.189-46.896-24.377 3.646 16.97 53.956 21.977-3.287-2.442-6.241zm7.144-15.975l-19.415-15.307 6.746 17.201 12.669-1.894zm-2.029-.598l-15.18-11.968 5.275 13.45 9.905-1.482zm71.452 12.631l-21.429 3.204-41.874-52.034 35.188-5.262c7.723-1.155 15.394-.024 22.173 2.685 6.767 2.704 12.514 6.93 16.461 11.835 3.918 4.869 5.459 9.702 4.024 13.622-1.438 3.926-5.838 6.862-13.56 8.016l-13.759 2.058 12.776 15.876zm-1.668-.652l-19.387 2.9-40.58-50.426 34.167-5.11c14.972-2.238 29.361 4.419 36.966 13.869 7.544 9.374 5.809 18.442-9.163 20.681l-14.78 2.21 12.777 15.876zm-23.11-30.138l11.263-1.685c1.477-.221 2.46-.695 2.876-1.328.399-.609.32-1.429-.559-2.522-.915-1.137-2.055-1.82-3.245-2.197-1.239-.393-2.689-.503-4.165-.282l-11.264 1.684 5.094 6.33zm88.323 21.288l-21.429 3.204-41.874-52.034 21.429-3.205 41.874 52.035zm-42.248-51.078l40.58 50.426-19.387 2.899-40.58-50.426 19.387-2.899zm-34.165 28.91c3.264-.488 4.821-2.161 2.691-4.807-2.19-2.722-5.816-3.62-9.079-3.132l-12.284 1.837 6.388 7.939 12.284-1.837z'
          fill='#fff'
        />
        <path
          transform='matrix(.62694 .77907 -.989 .1479 205.203 107.538)'
          stroke='#fff'
          strokeWidth={3}
          strokeDasharray='5 5'
          d='M0-1.5h117.171'
        />
        <path
          transform='matrix(.62694 .77907 -.989 .1479 368.562 83.11)'
          stroke='#fff'
          strokeWidth={3}
          strokeDasharray='5 5'
          d='M0-1.5h117.171'
        />
        <path
          transform='matrix(.989 -.1479 .62694 .77907 209.305 133.956)'
          stroke='#fff'
          strokeWidth={3}
          strokeDasharray='5 5'
          d='M0-1.5h198.727'
        />
        <path
          transform='matrix(.989 -.1479 .62694 .77907 252.346 187.44)'
          stroke='#fff'
          strokeWidth={3}
          strokeDasharray='5 5'
          d='M0-1.5h198.727'
        />
        <path d='M86.648 62.43V51.667l8.555 10.763h-8.555z' fill='#4658A2' />
      </g>
      <defs>
        <filter
          id='prefix__filter0_d_api_layer'
          x={0.572}
          y={2.961}
          width={633.38}
          height={426.558}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feOffset dx={-21} dy={85} />
          <feGaussianBlur stdDeviation={32.5} />
          <feColorMatrix values='0 0 0 0 0.045 0 0 0 0 0.0884 0 0 0 0 0.2 0 0 0 0.9 0' />
          <feBlend in2='BackgroundImageFix' />
          <feBlend in='SourceGraphic' />
        </filter>
        <filter
          id='prefix__filter1_f_api_layer'
          x={232.455}
          y={110.773}
          width={212.466}
          height={102.617}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation={5.5} result='effect1_foregroundBlur' />
        </filter>
        <linearGradient
          id='prefix__paint0_linear_api_layer'
          x1={359.176}
          y1={179.634}
          x2={374.702}
          y2={264.242}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4658A2' />
          <stop offset={1} stopColor='#2D4195' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SVGApiLayer;
